import { render } from "./UpdateTimeframe.vue?vue&type=template&id=dc4aa914"
import script from "./UpdateTimeframe.vue?vue&type=script&lang=js"
export * from "./UpdateTimeframe.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__